import { useState } from 'react';
import { StatusCodes } from 'http-status-codes';
import styled from 'styled-components';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import ProductsApi from '~/src/services/api/ProductsApi';
import { Link, useHistory } from 'react-router-dom';
import DataOperationsNav from '~/src/components/common/navigation/DataOperationsNav';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';
import { Colors } from '~/src/scss/common/style';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';

export default function ProductAnalysis(): JSX.Element {
  const [results, setResults] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  
  const startAnalysis = async (): Promise<void> => {
    setIsSubmitting(true);
    const res = await ProductsApi.analizeProducts();

    if (res.status === StatusCodes.OK) {
      setResults(res.data);
    }

    setIsSubmitting(false);
  };

  return (
    <WhitePad>
      <div style={{ display: 'flex' }}>
        <DataOperationsNav />
        <div style={{ width: '100%' }}>
          <TitleComponent title="Analize products" 
          titleLeft="Back"
          onLeftHandler={(): void => history.goBack()}
          />
          <FormWrapper>
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
              <StyleTitle>PRODUCT DATA ANALYSIS</StyleTitle>
              <ActionWrapper>
                <PrimaryButton title="Start" onClick={startAnalysis} isSubmitting={isSubmitting} />
              </ActionWrapper>
            </div>
          </FormWrapper>
          {results?.productsWithDuplicateGtins && <TableTitle>Products With Duplicate Gtins</TableTitle>}
          {results?.productsWithDuplicateGtins?.map((item) => {

            return (
              <div key={item.gtin}>
                <GtinNumber>{item.gtin}</GtinNumber>
                <Table>
                  <tbody>
                    {item?.products.map((product) => {

                      return (
                        <tr key={product.tempId}>
                          <td>
                            <Link to={`/products/edit/${product.genericProductId}`} target="_blank">
                              {product.genericProductName}
                            </Link>{' '}
                          </td>
                          <td>
                            (Orders: {product.orders})(Transactions: {product.transactions})
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            );
          })}

          {results?.genericsWithoutProducts && <TableTitle>Generic Products Without Manufacturer</TableTitle>}
          <Table>
            <tbody>
              {results?.genericsWithoutProducts?.map((item) => {

                return (
                  <tr key={'g' + item.genericProductId}>
                    <td>
                      <Link to={`/products/edit/${item.genericProductId}`} target="_blank">
                        {item.genericProductName}
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          {results?.productsWithMissingSmallerNumber && (
            <TableTitle>Products whose packaging has wrong Number</TableTitle>
          )}

          <Table>
            <tbody>
              {results?.productsWithMissingSmallerNumber?.map((item) => {

                return (
                  <tr key={'g' + item.genericProductId}>
                    <td>
                      <Link to={`/products/edit/${item.genericProductId}`} target="_blank">
                        {item.genericProductName}
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          {results?.productsWithMissingSmallerType && (
            <TableTitle>Products whose packaging is missing smaller Type</TableTitle>
          )}

          <Table>
            <tbody>
              {results?.productsWithMissingSmallerType?.map((item) => {

                return (
                  <tr key={'g' + item.genericProductId}>
                    <td>
                      <Link to={`/products/edit/${item.genericProductId}`} target="_blank">
                        {item.genericProductName}
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          {results?.productsWithMissingCuOrDu && (
            <TableTitle>Products whose packaging is missing CU or DU</TableTitle>
          )}

          <Table>
            <tbody>
              {results?.productsWithMissingCuOrDu?.map((item) => {

                return (
                  <tr key={'g' + item.genericProductId}>
                    <td>
                      <Link to={`/products/edit/${item.genericProductId}`} target="_blank">
                        {item.genericProductName}
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          {results?.productsWithDuplicatePackaging && <TableTitle>Products With Duplicate Packaging</TableTitle>}

          <Table>
            <tbody>
              {results?.productsWithDuplicatePackaging?.map((item) => {

                return (
                  <tr key={'g' + item.genericProductId}>
                    <td>
                      <Link to={`/products/edit/${item.genericProductId}`} target="_blank">
                        {item.genericProductName}
                      </Link>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>
    </WhitePad>
  );
}

const Table = styled.div`
  a {
    color: #343434;
  }
  display: table;
  overflow: hidden;
  width: 100%;
  border-radius: 10px;
  tr {
    width: 50%;
  }
  td {
    padding: 13px;
    font-size: 14px;
  }
  tr:nth-child(even) {
    background-color: #fbfbfb;
  }
  tr:nth-child(odd) {
    background-color: #f4f4f4;
  }
`;

const GtinNumber = styled.div`
font-weight: 700;
font-size: 15px
line-height: 17px;
text-transform: uppercase;
color: ${Colors.darkBrown};
margin-bottom: 8px;
margin-top: 22px;
margin-left: 5px;
`;

const TableTitle = styled.h2`
margin: 87px 0;
font-weight: 700;
font-size: 20px
line-height: 24px;
text-transform: uppercase;
color: ${Colors.darkBrown};
text-align: center;
`;

const StyleTitle = styled.h2`
  margin-bottom: 36px;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  text-transform: uppercase;
  color: ${Colors.darkBrown};
  text-align: center;
  padding: 0;
`;

const ActionWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
